module.exports = __webpack_public_path__ + "img/64e8446.png";